module.exports = __webpack_public_path__ + "img/upload.8c294c5ff4da27b077607047b457d090.8c294c5f.png";